(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/use-check-player-after-session.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/use-check-player-after-session.js');
'use strict';

const {
  logger
} = svs.playerLogin;
const {
  useUrlHelper
} = svs.playerLogin.sharedComponents;

const parseLastLoginTime = (inDate, withSeconds) => "".concat(inDate.substr(0, 10), " ").concat(withSeconds ? inDate.substr(11, 8) : inDate.substr(11, 5));
const useCheckPlayerAfterSession = () => {
  const {
    navigateToReturnUrl
  } = useUrlHelper();

  const checkPlayerAfterSessionAsync = async (isBankId, response, isQrCode) => {
    var _response$session;
    logger.debug('Got login from backend, continue...');
    let optLabel;
    if (isBankId) {
      optLabel = "bankid".concat(isQrCode ? ' qr' : '');
    } else {
      optLabel = 'frejaeid';
    }
    const successEvent = {
      category: 'Users',
      action: 'Login Success',
      opt_label: optLabel
    };
    let afterLastLoginTimeSetCallback;
    const loginStartTime = svs.components.Storage.browser.get('loginStartTime', 'player-login');
    if (loginStartTime) {
      successEvent.opt_value = Date.now() - loginStartTime;
    }
    const isBlocked = response === null || response === void 0 || (_response$session = response.session) === null || _response$session === void 0 ? void 0 : _response$session.isBlocked;
    if (isBlocked || response.userNotifications && (response.userNotifications.HAS_SUSPENSION || response.userNotifications.SHOW_SUSP_REMINDER)) {
      afterLastLoginTimeSetCallback = function () {
        if (isBlocked) {
          svs.accountservices.national_suspension_message.showNationalSuspensionMessage(navigateToReturnUrl);
        } else if (response.userNotifications.HAS_SUSPENSION) {
          svs.accountservices.suspension_message.showSuspensionMessage(navigateToReturnUrl);
        } else {
          svs.accountservices.suspension_message.showSuspensionEndMessage(navigateToReturnUrl);
        }
      };
    } else {
      afterLastLoginTimeSetCallback = function () {
        navigateToReturnUrl();
      };
    }
    const lastLoginTime = (response === null || response === void 0 ? void 0 : response.lastLoginTime) || '';
    svs.accountservices.martech_helper.setPersonalizedContentFlag(() => {
      var _response$userNotific;
      svs.components.analytics.trackEvent(successEvent);
      if (response !== null && response !== void 0 && (_response$userNotific = response.userNotifications) !== null && _response$userNotific !== void 0 && _response$userNotific.PART_OF_CAMPAIGN) {
        svs.core.userSession.set('partofcampaign', true, () => {
          svs.core.userSession.set('lastLoginTime', parseLastLoginTime(lastLoginTime, false), afterLastLoginTimeSetCallback);
        });
      } else {
        svs.core.userSession.set('lastLoginTime', parseLastLoginTime(lastLoginTime, false), afterLastLoginTimeSetCallback);
      }
    });
  };
  return checkPlayerAfterSessionAsync;
};
svs.playerLogin.sharedComponents.useCheckPlayerAfterSession = useCheckPlayerAfterSession;

 })(window);